<template>
  <div>
    <NavBarAdmin></NavBarAdmin>
    <h4 class="mt-4 mb-3">Lista de precios</h4>
    <ListPrices @sendPriceId="getPriceId"></ListPrices>
    <EditPrice v-show="showEditPrice" :getPriceIdToEdit="priceId" @hideEditPrice="hideEditPrice"></EditPrice>
    <FooterAdmin></FooterAdmin>
  </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue";
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue";
import ListPrices from "@/components/Admin/Prices/ListPricesAdminComponent.vue";
import EditPrice from "@/components/Admin/Prices/EditPriceComponent.vue";
export default {
  data() {
    return {
      showEditPrice: false,
      priceId: null,
      showRegisterPrice: false,
    };
  },
  components: {
    NavBarAdmin,
    FooterAdmin,
    ListPrices,
    EditPrice,
  },
  methods: {
    getPriceId(data) {
      this.priceId = data;
      //console.log(this.priceId);
      this.showEditPrice = true;
    },
    hideEditPrice(data) {
      this.showEditPrice = data;
      this.priceId = null;
    },
    showPriceRegister() {
      this.showRegisterPrice = true;
    }
  },
};
</script>